import React, { useEffect, useState } from "react";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";
import { satc_users } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import addNumToList from "Helpers/addNumToList";
import { ReactSVG } from "react-svg";
import Search from "Assets/svg/icon/search.svg";
import cellEditFactory from "react-bootstrap-table2-editor";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import AlertDialog from "Components/AlertDialog/AlertDialog";

export default function UserTable({ row }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [changeStatusParam, setChangeStatusParam] = useState({});
  const [sizePerPage, setSizePerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const setValue = (name, value) => {
    setSearch(value);
  };

  const onSearch = async (e) => {
    e.preventDefault();
    caller({
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      Limit: sizePerPage,
      Page: 1,
      Name: convertToEnglishNumber(search),
      GroupId: row.Id,
    });
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    caller({
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      Limit: sizePerPage,
      Page: 1,
      GroupId: row.Id,
    });
  };

  useEffect(() => {
    setLoading(true);
    setData([]);
    const params = {
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      Limit: sizePerPage,
      Page: 1,
      GroupId: row.Id,
    };
    caller(params);
  }, []);

  const caller = async (params) => {
    try {
      setLoading(true);
      const response = await AccountService.getAccountGroupUsers(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setData(
          addNumToList(response.data.Value, params.Page, params.Limit, {
            GroupId: row.Id,
          })
        );
        setPagination(response.data.Pagination);
      }
      setLoading(false);
    } catch (e) {
      showNotify({ text: "getDataError", customClass: "error" });
    }
  };

  const OnCellChanged = (oldValue, newValue, _row, column, done) => {
    const updateNewValue = JSON.parse(newValue);
    if (oldValue !== updateNewValue) {
      setAlertMessage(
        t("change_user_active")
          .replace("@USERNAME", _row.DisplayName)
          .replace("@NOW", !oldValue ? t("active") : t("disable"))
          .replace("@UPDATE", !updateNewValue ? t("active") : t("disable"))
      );
      setChangeStatusParam({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Users: [{ Id: _row.Id, IsDisable: updateNewValue }],
      });
      setShowAlert(true);
    } else {
      done(false);
    }
  };

  const handleChangeStatus = () => {
    changeActiveBySuperAdmin(changeStatusParam);
  };

  const changeActiveBySuperAdmin = async (params) => {
    setLoading(true);
    setShowAlert(false);
    const response = await AccountService.putDisableUserBySuperAdmin(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      showNotify({ text: t("mission_accomplished"), customClass: "success" });
      setTimeout(() => {
        const _params = {
          KeyGroup: read("groupAKey"),
          KeyUser: read("userAKey"),
          Limit: sizePerPage,
          Page: currentPage,
          GroupId: row.Id,
        };
        caller(_params);
      }, 500);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const onTableChange = (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: sizePerPage,
        Page: page,
        GroupId: row.Id,
      };
      caller(params);
    }
  };

  const setPagination = (pagination) => {
    setSizePerPage(pagination.Limit);
    setCurrentPage(pagination.Page);
    setTotal(pagination.Total);
  };

  return (
    <>
      <AlertDialog
        showAlert={showAlert}
        type="alertWarning"
        onClose={() => setShowAlert(false)}
        onClickOk={handleChangeStatus}
        okTitle={<Translator id="yes" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={alertMessage}
      />
      <Grid container spacing={2} className="mt-2">
        <Grid item md={4} sm={6} xs={12}>
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            placeholder={t("usernameSearch")}
            icon={<ReactSVG src={Search} />}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <RemoteTable
            data={data}
            columns={satc_users}
            loading={loading}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              beforeSaveCell: (oldValue, newValue, row, column, done) =>
                OnCellChanged(oldValue, newValue, row, column, done),
            })}
            sizePerPageList={
              {
                text: "5",
                value: 5,
              }
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
